import { render } from "./Race6.vue?vue&type=template&id=56d3a7b1&scoped=true"
import script from "./Race6.vue?vue&type=script&lang=js"
export * from "./Race6.vue?vue&type=script&lang=js"

import "./Race6.vue?vue&type=style&index=0&id=56d3a7b1&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/5rs1AT96L/0/prj/cashier/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d3a7b1"]])

export default __exports__